import crypto from 'crypto';
import { fetchRSAKey, sendFileData } from '../services/digibarn-upload-service';

export default async function sendFiles(files, unit) {
  const keyRes = await fetchRSAKey();
  return await Promise.all(files.map((file) => encryptAndSendFile(file, keyRes.key, unit)));
}

async function encryptAndSendFile(file, rsaKey, unit) {
  const wcKey = await window.crypto.subtle.generateKey(
    {
      name: 'AES-GCM',
      length: 256,
    },
    true,
    ['encrypt', 'decrypt']
  );
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const gcmPassword = window.crypto.getRandomValues(new Uint8Array(12));
  const buffer = await file.file.arrayBuffer();
  const encryptedBytes = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
      additionalData: Buffer.from(gcmPassword),
      tagLength: 128,
    },
    wcKey,
    Buffer.from(buffer, 'utf-8')
  );

  const exportedKey = await window.crypto.subtle.exportKey('raw', wcKey);

  const encryptedKey = crypto.publicEncrypt(
    {
      key: rsaKey,
      padding: crypto.constants.RSA_PKCS1_PADDING,
    },
    Buffer.from(exportedKey)
  );

  const encryptedGCMPassword = crypto.publicEncrypt(
    {
      key: rsaKey,
      padding: crypto.constants.RSA_PKCS1_PADDING,
    },
    Buffer.from(gcmPassword)
  );

  const body = [
    encryptedKey.toString('base64').replaceAll(/=/g, ''),
    encryptedGCMPassword.toString('base64').replaceAll(/=/g, ''),
    Buffer.from(iv).toString('base64').replaceAll(/=/g, ''),
    `${file.file.name}`,
    `${file.file.type}`,
    `${unit}`,
    Buffer.from(encryptedBytes).toString('base64').replaceAll(/=/g, ''),
  ].join('\n');

  return sendFileData(body);
}
